/**
 * Ultima versione delle Novità vista dall'utente, ricordata nel browser.
 *
 * Basta un ricordo locale: se si perde (altro browser, dati cancellati, finestra anonima) l'avviso
 * delle novità ricompare una volta, e non succede altro. La chiave porta l'id dell'utenza, perche'
 * sui computer condivisi delle sedi ognuno veda l'avviso suo. localStorage puo' mancare o rifiutare
 * la scrittura: allora vale il ricordo in memoria, fino al ricaricamento della pagina.
 */
const inMemoria = new Map<string, string>()

const chiave = (utente: string) => `cidis.novita-vista.${utente}`

export function ultimaVista(utente: string): string | null {
  try {
    const valore = window.localStorage.getItem(chiave(utente))
    if (valore) return valore
  } catch { /* archivio del browser non disponibile: si usa la memoria */ }
  return inMemoria.get(utente) ?? null
}

export function segnaVista(utente: string, versione: string) {
  inMemoria.set(utente, versione)
  try {
    window.localStorage.setItem(chiave(utente), versione)
  } catch { /* archivio del browser pieno o vietato: resta il ricordo in memoria */ }
}
